import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { FooterDisclosures } from "@/components/FooterDisclosures";
import { Logo } from "@/components/Logo";
import { FooterNavLinks } from "@/components/FooterNavLinks";

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground pt-16 pb-8 border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top: brand + consolidated nav columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-10 xl:gap-8 mb-12">
          {/* Brand */}
          <div className="md:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center mb-5">
              {/* Full horizontal lockup on sm+ viewports */}
              <div className="hidden xs:block sm:block">
                <Logo size="lg" variant="dark" />
              </div>
              {/* Compact monogram-only variant for tight mobile layouts to eliminate overflow */}
              <div className="xs:hidden sm:hidden flex items-center gap-2.5">
                <Logo monogram size="md" />
                <div className="flex flex-col">
                  <span className="font-serif text-base font-semibold tracking-wide text-white leading-tight">
                    SRG
                  </span>
                  <span className="text-[8.5px] uppercase tracking-[0.18em] text-accent font-medium leading-tight">
                    Consulting PLLC
                  </span>
                </div>
              </div>
            </Link>
            <p className="text-primary-foreground/65 text-sm leading-relaxed max-w-xs mb-6">
              Strategic financial guidance for business owners, executives, and
              families who want clarity before making major financial decisions.
            </p>
            <div className="space-y-1.5 text-sm text-primary-foreground/70">
              <a
                href="tel:+18669904985"
                className="block hover:text-accent transition-colors"
              >
                1-866-990-4985
              </a>
              <a
                href="mailto:info@srgconsultingpllc.com"
                className="block hover:text-accent transition-colors"
              >
                info@srgconsultingpllc.com
              </a>
            </div>
          </div>

          {/* Four consolidated nav columns */}
          <FooterNavLinks />
        </div>

        {/* Regulatory disclosures */}
        <FooterDisclosures />

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-8 pt-8 border-t border-accent/15 gap-5 md:gap-0">
          <p className="text-center md:text-left text-primary-foreground/55 text-xs">
            &copy; {new Date().getFullYear()} SRG Consulting PLLC · License No.
            19177286 · All rights reserved.
          </p>

          <a
            href="https://azcc.gov/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-primary-foreground/55 hover:text-accent transition-colors"
            aria-label="Verified by Arizona Corporation Commission"
          >
            <ShieldCheck className="w-4 h-4 text-accent" />
            <span className="text-xs font-medium">
              Verified · AZ Corporation Commission
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
